"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var __1 = require("../../");
var chat_1 = __importDefault(require("./chat"));
var convoList_1 = require("./convoList");
var EloiseChat = function (_a) {
    var holeCoords = _a.holeCoords, setHoleCoords = _a.setHoleCoords;
    var _b = (0, __1.useEloise)(), logic = _b.logic, theme = _b.theme, siteConfig = _b.siteConfig;
    var _c = (0, react_1.useState)(), selectedConvo = _c[0], setSelectedConvo = _c[1];
    var _d = (0, react_1.useState)(""), message = _d[0], setMessage = _d[1];
    var _e = (0, react_1.useState)([
        {
            text: siteConfig.eloiseConfig.initMessage,
            sender: "ai",
            type: "Text",
        },
    ]), messages = _e[0], setMessages = _e[1];
    // Retrieve selectedConvo from localStorage on component mount
    (0, react_1.useEffect)(function () {
        var storedSelectedConvo = localStorage.getItem("selectedConvo");
        if (storedSelectedConvo) {
            setSelectedConvo(JSON.parse(storedSelectedConvo));
        }
    }, []);
    var handleConvoSelection = function (convo) {
        setSelectedConvo(convo);
        localStorage.setItem("selectedConvo", JSON.stringify(convo));
    };
    if (selectedConvo) {
        return (react_1.default.createElement(chat_1.default, { convo: selectedConvo, holeCoords: holeCoords, setHoleCoords: setHoleCoords, back: function () {
                setSelectedConvo(undefined);
                localStorage.removeItem("selectedConvo");
            } }));
    }
    else {
        return react_1.default.createElement(convoList_1.ConvoList, { select: handleConvoSelection });
    }
};
exports.default = EloiseChat;
